import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { ReactComponent as DownArrow } from './img/diagram-arrow.svg';
import { getURLForNavKey } from './lib/data';
import { BrowserView, TabletView, MobileOnlyView, isBrowser, isTablet } from 'react-device-detect';
import './SummaryTLDR.css';
import './FigureOutWhatYouWant.css';

import TLDR1 from './img/content/TLDR_1.png';
import TLDR2 from './img/content/TLDR_2.png';
import TLDR3 from './img/content/TLDR_3.png';

import DesktopTLDR1 from './img/content/Desktop_Summary_9.png';
import DesktopTLDR2 from './img/content/Desktop_Summary_10.png';
import DesktopTLDR3 from './img/content/Desktop_Summary_11.png';

import Ownership from './img/content/TLDR_4_ownership.png';
import Precision from './img/content/TLDR_4_precision.png';
import Curiosity from './img/content/TLDR_6_curiosity.png';
import Communication from './img/content/TLDR_7_communication.png';
import Expertise from './img/content/TLDR_8_expertise.png';
import Mentorship from './img/content/TLDR_8_mentorship.png';
import EmotionalIntelligence from './img/content/TLDR_9_emotionalintelligence.png';
import Impact from './img/content/TLDR_9_impact.png';

import DesktopOwnership from './img/content/Desktop_Summary_19.png';
import DesktopPrecision from './img/content/Desktop_Summary_18.png';
import DesktopCuriosity from './img/content/Desktop_Summary_17.png';
import DesktopCommunication from './img/content/Desktop_Summary_16.png';
import DesktopExpertise from './img/content/Desktop_Summary_15.png';
import DesktopImpact from './img/content/Desktop_Summary_14.png';
import DesktopMentorship from './img/content/Desktop_Summary_13.png';
import DesktopEmotionalIntelligence from './img/content/Desktop_Summary_12.png';

export default class SummaryTLDR extends Component {
  static propTypes = {
    lines: PropTypes.array,
  }

  render() {
    const { lines } = this.props;

    return (
      <section className="summary-tldr">

        {/* ------- What Is Culture? ------- */}
        <section className="What-Is-Culture section">
          <h1>What is Culture?</h1>
          <h4>How we build culture</h4>
          <p>
            Culture is the set of beliefs and behaviors that determine how we interact.
          </p>
          <p>
            It’s the product of the values, customs, traditions, and meanings that make us unique. We create it with every decision we make in the office. 
          </p>
          <MobileOnlyView>
            <img src={TLDR1} width="100%" className="culture-image" />
          </MobileOnlyView>
          <BrowserView>
            <img src={DesktopTLDR1} width="100%" className="culture-image" />
          </BrowserView>
          <TabletView>
            <img src={DesktopTLDR1} width="100%" className="culture-image" />
          </TabletView>
          <Row className="skills-actions-purpose" gutter={16}>
            <Col span={12}>
              <MobileOnlyView>
                <img src={TLDR2} width="100%" />
              </MobileOnlyView>
              <BrowserView>
                <img src={DesktopTLDR2} width="100%" />
              </BrowserView>
              <TabletView>
                <img src={DesktopTLDR2} width="100%" />
              </TabletView>
            </Col>
            <Col span={12}>
              <h5>Skills</h5>
              <p>The talent and experience we bring from previous jobs (and life) is the raw materials.</p>
              <h5>Actions</h5>
              <p>How we work together, how companies put values to work</p>
              <h5>Purpose</h5>
              <p>Our purpose allows us to stand for something bigger than any product, result, or metric. It’s the north star, our “why”</p>
            </Col>
          </Row>
        </section>

        {/* ------- Purpose ------- */}
        <section className="Purpose section">
          <section className="purpose-content">
            <h1>Purpose</h1>
            <h4>Why our company exists</h4>
            <p>
              Getting out of bed requires a purpose that inspires. This is ours: to help people own the moment.
            </p>

            <MobileOnlyView>
              <img src={TLDR3} width="100%" className="purpose-image" />
            </MobileOnlyView>
            <BrowserView>
              <img src={DesktopTLDR3} width="100%" className="purpose-image" />
            </BrowserView>
            <TabletView>
              <img src={DesktopTLDR3} width="100%" className="purpose-image" />
            </TabletView>

            <h5>Why</h5>
            <p className="definition">
              A purpose, cause, or belief. The reason an organization exists.
            </p>
            <p className="conclusion">Own the Moment.</p>

            <h5>How</h5>
            <p className="definition">
              The things that set an organization apart from their competition.
            </p>
            <p className="conclusion">
              Modern experience, personal service, elevated style and fit, social relevance, confidence coaching.
            </p>

            <h5>What</h5>
            <p className="definition">
              The products or services an organization offers.
            </p>
            <p className="conclusion">Formalwear rentals and sales.</p>

            <p className="quote">&ldquo;</p>
            <p className="emphasis">To own the moment is to show up as the best version of yourself.</p>
            <p className="quote">&rdquo;</p>

            {(isBrowser || isTablet) &&
              <section>
                <section className="figure-out-what-you-want">
                  <h3>Figure out what you want,</h3>
                  <DownArrow className="down-arrow" />
                  <p>Know yourself</p>
                  <p>Desire growth</p>
                  <p>Have intent and purpose</p>
                </section>

                <section className="figure-out-what-you-want">
                  <h3>and learn how to ask for it.</h3>
                  <DownArrow className="down-arrow" />
                  <p>Communicate</p>
                  <p>Give feedback</p>
                  <p>Be open</p>
                  <p>Be vulnerable</p>
                </section>

                <section className="figure-out-what-you-want">
                  <h3>We'll do the rest.</h3>
                  <DownArrow className="down-arrow" />
                  <p>Support</p>
                  <p>Development</p>
                  <p>Tools</p>
                  <p>Resources/training</p>
                  <p>Coaching</p>
                  <p>(Snacks)</p>
                </section>
              </section>
            }
          </section>
        </section>

        {/* ------- Actions ------- */}
        <section className="Actions section">
          <section className="action-content">
            <h1>Actions</h1>
            <h4>How teams put values to work</h4>
            <p>
              How well we work together determines how much we accomplish.
            </p>
            <p>
              Actions—how we interact and behave with one another—are the bridge between individual contributors and the mission.
            </p>
            <p style={{ marginBottom: 32 }}>
              It’s how companies put values to work.
            </p>

            <section className="list">
              <h3>Know Yourself</h3>
              <ul>
                <li>Don't bring ego to work</li>
                <li>Do bring our whole selves to work</li>
                <li>We can only change ourselves</li>
              </ul>
            </section>

            <section className="list">
              <h3>Embrace Feedback</h3>
              <ul>
                <li>It's the foundation for strong relationships</li>
                <li>Feedback goes in all directions</li>
                <li>No one can read our minds</li>
              </ul>
            </section>

            <section className="list">
              <h3>Start with Questions</h3>
              <ul>
                <li>Prioritize discovery</li>
                <li>Understand the problem</li>
                <li>Beginner's mind: open, eager, no preconceptions</li>
              </ul>
            </section>

            <section className="list">
              <h3>Lean into the Hard Stuff</h3>
              <ul>
                <li>Don't be shy about failure</li>
                <li>Embrace the thing we're afraid to do</li>
              </ul>
            </section>

            <section className="list">
              <h3>Sense and Respond</h3>
              <ul>
                <li>Embrace uncertainty</li>
                <li>Come to problems as a team</li>
                <li>Move forward as a team</li>
              </ul>
            </section>
          </section>
        </section>

        {/* ------- Skills ------- */}
        <section className="Skills section">
          <section className="action-content">
            <h1>Skills</h1>
            <h4>What individuals contribute</h4>
            <p>
              The Skills Matrix is a framework that allows everyone to understand the tools, knowledge, and behaviors that are necessary for career growth and success.
            </p>
            <p>
              We us the Skills Matrix to facilitate career development conversations, recognize achievement and growth, and call out areas that need work.
            </p>
            <h2>Skills</h2>
            <section className="skills-grid">
              <BrowserView>
                <section>
                  <Row gutter={64} style={{ marginTop: 24 }}>
                    <Col span={6}>
                      <img width="90%" src={DesktopOwnership} />
                    </Col>
                    <Col span={6}>
                      <img width="90%" src={DesktopPrecision} />
                    </Col>
                    <Col span={6}>
                      <img width="90%" src={DesktopCuriosity} />
                    </Col>
                    <Col span={6}>
                      <img width="90%" src={DesktopCommunication} />
                    </Col>
                  </Row>
                  <Row gutter={64} style={{ marginTop: 16, marginBottom: 12 }}>
                    <Col span={6}>
                      <h4>Ownership</h4>
                    </Col>
                    <Col span={6}>
                      <h4>Precision</h4>
                    </Col>
                    <Col span={6}>
                      <h4>Curiosity</h4>
                    </Col>
                    <Col span={6}>
                      <h4>Communication</h4>
                    </Col>
                  </Row>

                  <Row gutter={64}>
                    <Col span={6}>
                      <img width="90%" src={DesktopExpertise} />
                    </Col>
                    <Col span={6}>
                      <img width="90%" src={DesktopMentorship} />
                    </Col>
                    <Col span={6}>
                      <img width="90%" src={DesktopImpact} />
                    </Col>
                    <Col span={6}>
                      <img width="90%" src={DesktopEmotionalIntelligence} />
                    </Col>
                  </Row>
                  <Row gutter={64} style={{ marginTop: 16, marginBottom: 12 }}>
                    <Col span={6}>
                      <h4>Expertise</h4>
                    </Col>
                    <Col span={6}>
                      <h4>Mentorship</h4>
                    </Col>
                    <Col span={6}>
                      <h4>Impact</h4>
                    </Col>
                    <Col span={6}>
                      <h4>Emotional Intelligence</h4>
                    </Col>
                  </Row>
                </section>
              </BrowserView>

              <TabletView>
                <section>
                  <Row gutter={64} style={{ marginTop: 24 }}>
                    <Col span={12}>
                      <img width="90%" src={DesktopOwnership} />
                    </Col>
                    <Col span={12}>
                      <img width="90%" src={DesktopPrecision} />
                    </Col>
                  </Row>
                  <Row gutter={64} style={{ marginTop: 16, marginBottom: 12 }}>
                    <Col span={12}>
                      <h4>Ownership</h4>
                    </Col>
                    <Col span={12}>
                      <h4>Precision</h4>
                    </Col>
                  </Row>

                  <Row gutter={64}>
                    <Col span={12}>
                      <img width="90%" src={DesktopCuriosity} />
                    </Col>
                    <Col span={12}>
                      <img width="90%" src={DesktopCommunication} />
                    </Col>
                  </Row>
                  <Row gutter={64} style={{ marginTop: 16, marginBottom: 12 }}>
                    <Col span={12}>
                      <h4>Curiosity</h4>
                    </Col>
                    <Col span={12}>
                      <h4>Communication</h4>
                    </Col>
                  </Row>

                  <Row gutter={64}>
                    <Col span={12}>
                      <img width="90%" src={DesktopExpertise} />
                    </Col>
                    <Col span={12}>
                      <img width="90%" src={DesktopMentorship} />
                    </Col>
                  </Row>
                  <Row gutter={64} style={{ marginTop: 16, marginBottom: 12 }}>
                    <Col span={12}>
                      <h4>Expertise</h4>
                    </Col>
                    <Col span={12}>
                      <h4>Mentorship</h4>
                    </Col>
                  </Row>

                  <Row gutter={64}>
                    <Col span={12}>
                      <img width="90%" src={DesktopImpact} />
                    </Col>
                    <Col span={12}>
                      <img width="90%" src={DesktopEmotionalIntelligence} />
                    </Col>
                  </Row>
                  <Row gutter={64} style={{ marginTop: 16, marginBottom: 12 }}>
                    <Col span={12}>
                      <h4>Impact</h4>
                    </Col>
                    <Col span={12}>
                      <h4>Emotional Intelligence</h4>
                    </Col>
                  </Row>
                </section>
              </TabletView>

              <MobileOnlyView>
                <section>
                  <Row gutter={64} style={{ marginTop: 24 }}>
                    <Col span={12}>
                      <img width="90%" src={Ownership} />
                    </Col>
                    <Col span={12}>
                      <img width="90%" src={Precision} />
                    </Col>
                  </Row>
                  <Row gutter={64} style={{ marginTop: 16, marginBottom: 12 }}>
                    <Col span={12}>
                      <h4>Ownership</h4>
                    </Col>
                    <Col span={12}>
                      <h4>Precision</h4>
                    </Col>
                  </Row>

                  <Row gutter={64}>
                    <Col span={12}>
                      <img width="90%" src={Curiosity} />
                    </Col>
                    <Col span={12}>
                      <img width="90%" src={Communication} />
                    </Col>
                  </Row>
                  <Row gutter={64} style={{ marginTop: 16, marginBottom: 12 }}>
                    <Col span={12}>
                      <h4>Curiosity</h4>
                    </Col>
                    <Col span={12}>
                      <h4>Communication</h4>
                    </Col>
                  </Row>

                  <Row gutter={64}>
                    <Col span={12}>
                      <img width="90%" src={Expertise} />
                    </Col>
                    <Col span={12}>
                      <img width="90%" src={Mentorship} />
                    </Col>
                  </Row>
                  <Row gutter={64} style={{ marginTop: 16, marginBottom: 12 }}>
                    <Col span={12}>
                      <h4>Expertise</h4>
                    </Col>
                    <Col span={12}>
                      <h4>Mentorship</h4>
                    </Col>
                  </Row>

                  <Row gutter={64}>
                    <Col span={12}>
                      <img width="90%" src={Impact} />
                    </Col>
                    <Col span={12}>
                      <img width="90%" src={EmotionalIntelligence} />
                    </Col>
                  </Row>
                  <Row gutter={64} style={{ marginTop: 16, marginBottom: 12 }}>
                    <Col span={12}>
                      <h4>Impact</h4>
                    </Col>
                    <Col span={12}>
                      <h4>Emotional Intelligence</h4>
                    </Col>
                  </Row>
                </section>
              </MobileOnlyView>
            </section>
            <p>
              <a href={getURLForNavKey("view-the-skills-matrix")}>
                View the skills matrix
              </a>
              &nbsp;in its native format.
            </p>
          </section>
        </section>
      </section>
    );
  }
}
